import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _wechatStatistics() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/wechat-statistics`,
    method: 'get',
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _wechatVisitStatistics(
  {
    startAt,
    endAt,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/wechat-visit-statistics`,
    method: 'get',
    params: {
      startAt,
      endAt,
    },
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _baseStatistics() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/base-statistics`,
    method: 'get',
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _monthStatistics() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/month-statistics`,
    method: 'get',
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _paidOrderStatistics(
  {
    startAt,
    endAt,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/paid-order-statistics`,
    method: 'get',
    params: {
      startAt,
      endAt,
    },
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _paidSkuQtyStatistics(
  {
    startAt,
    endAt,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/paid-sku-qty-statistics`,
    method: 'get',
    params: {
      startAt,
      endAt,
    },
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _paidOrderQtyStatistics(
  {
    startAt,
    endAt,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/paid-order-qty-statistics`,
    method: 'get',
    params: {
      startAt,
      endAt,
    },
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _refundOrderStatistics(
  {
    startAt,
    endAt,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/refund-order-statistics`,
    method: 'get',
    params: {
      startAt,
      endAt,
    },
  });
}

export default {};
